import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";
import { styleBySection } from "./util/stepSectionStyle";

export function getHDLaneRestrictionStyleNormal(feature) {
  return getHDLaneRestrictionColorStyle(feature);
}

export function getHDLaneRestrictionStyleClick(feature) {
  return getHDLaneRestrictionColorStyle(feature, true, false);
}

export function getHDLaneRestrictionStyleHover(feature) {
  return getHDLaneRestrictionColorStyle(feature, false, true);
}

const HIDDEN = [
  new Style({
    stroke: new Stroke({
      color: "transparent",
      width: 0,
    }),
  }),
];

// bus ==> maroon, hgv ==> purple, psv ==> blue, taxi ==> yellow, hov ==> orange,
// motor_vehicle restriction ==> darkgrey, else grey.
//
// `tags` here holds scalar values only: where a tag is step-encoded,
// styleBySection() has already resolved it to the value that applies to the
// section being drawn (or undefined where no section covers it).
function classifyHDLaneRestriction(tags) {
  if (tags.vehicleRestrictionBus === "yes") {
    return { color: "maroon", width: 4, backgroundWidth: 6 };
  }
  if (tags.vehicleRestrictionHGV === "yes") {
    return { color: "purple", width: 4, backgroundWidth: 6 };
  }
  if (tags.vehicleRestrictionPSV === "yes") {
    return { color: "blue", width: 4, backgroundWidth: 6 };
  }
  if (tags.vehicleRestrictionTaxi === "yes") {
    return { color: "yellow", width: 4, backgroundWidth: 6 };
  }
  if (tags.hovLane === "yes" || tags.hov === "yes") {
    return { color: "orange", width: 4, backgroundWidth: 6 };
  }
  if (
    tags.vehicleRestrictionMotorVehicle !== undefined &&
    tags.vehicleRestrictionMotorVehicle !== "yes"
  ) {
    return { color: "darkgrey", width: 4, backgroundWidth: 6 };
  }
  return { color: "grey", width: 1, backgroundWidth: 2 };
}

function getHDLaneRestrictionColorStyle(feature, click = false, hover = false) {
  const tags = extractTags(feature);
  if (
    tags.hdMap !== "lane_center_line" &&
    tags.hdMap !== "lane_trajectory_line"
  ) {
    return HIDDEN;
  }

  return styleBySection(
    feature,
    tags,
    classifyHDLaneRestriction,
    (descriptor, geometry) => [
      new Style({
        geometry: geometry,
        stroke: new Stroke({
          color: "white",
          width: hover || click ? 6 : descriptor.backgroundWidth,
        }),
      }),
      new Style({
        geometry: geometry,
        stroke: new Stroke({
          color: descriptor.color,
          width: descriptor.width,
        }),
      }),
    ],
  );
}
